import { render, staticRenderFns } from "./ProjectSearch.vue?vue&type=template&id=771ca796&scoped=true&"
import script from "./ProjectSearch.vue?vue&type=script&lang=js&"
export * from "./ProjectSearch.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSearch.vue?vue&type=style&index=0&id=771ca796&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771ca796",
  null
  
)

export default component.exports